

import React from 'react';
import { motion } from 'framer-motion';
import { Library } from 'lucide-react';
import Slider from 'react-slick'; // Import the slider
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import SidebarGalleryPage from '../Main/Sidebargallery';

// Features Data
const features = [
  { title: "RGPV CENTRAL LIBRARY has provided free access to e-books in Engineering and Science Domain for students and staff of all Government Engineering Colleges and Polytechnics affiliated to RGPV" },
  { title: "The students and Faculty can download “RGPV Digital Library “App on their Android smart phones and get access to 85 Engineering and Science e-books." },
  { title: "The students and Faculty can download “Pearson e-library “App on their Android smart phones and get access to 66 Engineering and Science e-books." },
  { title: "Our college is a member of NDL, National Digital Library. All the students and staff can register and benefit from the learning material from NDL from their site https://ndl.iitkgp.ac.in" }
];

// Scroller Data
const scrollerData = [
  { image: "https://www.gwpcs.org/admin/images/digital_library/ndl.png", link: "https://ndl.iitkgp.ac.in/" },
  { image: "https://www.gwpcs.org/admin/images/digital_library/rgpv.png", link: "https://www.kopykitab.com/subdomain/rgpv2019/" },
  { image: "https://www.gwpcs.org/admin/images/digital_library/epgp.png", link: "https://epgp.inflibnet.ac.in/" },
  { image: "https://www.gwpcs.org/admin/images/digital_library/nptel.jpg", link: "https://nptel.ac.in/" },
  { image: "https://www.gwpcs.org/admin/images/digital_library/person.jpg", link: "https://elibrary.in.pearson.com/" }
];

export default function LibrarySection() {
  // Settings for the slider
  const sliderSettings = {
    dots: true,         // Show dots for navigation
    infinite: true,     // Infinite scrolling
    speed: 500,         // Transition speed
    autoplay: true,     // Auto play images
    autoplaySpeed: 3000, // Time between transitions
    slidesToShow: 3,    // Number of slides to show at once
    slidesToScroll: 1,  // Number of slides to scroll at once
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <div className="min-h-screen bg-gary-100 p-6">
      {/* Main Content */}
      <div className="max-w-7xl mx-auto p-4 md:p-6 flex flex-col lg:flex-row gap-8">
        {/* Left Column - Library Section */}
        <motion.div
          className="lg:w-2/3"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="space-y-6">
            <div className="bg-white p-2 rounded-lg border-[#00BFA5] border-4">
              <h2 className="text-xl font-bold mb-4 flex items-center gap-2 bg-[#00BFA5] text-white p-4 rounded-sm">
                <Library className="w-6 h-6" />
                Digital Library
              </h2>
              <div className="space-y-4">
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.2 }}
                >
                  <p className='ml-2'>The Digital Library comprises e-books, e-journals, e-research papers, e-thesis, e-learning material, etc. in text, audio, PPT, video formats. It can be accessed from the library or anywhere through the internet by authorized students and staff.</p>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.3 }}
                >
                  <ul className="list-disc pl-5 ml-2 space-y-1 mb-2">
                    {features.map((feature, index) => (
                      <motion.li
                        key={index}
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.2 + index * 0.1 }}
                      >
                        {feature.title}
                      </motion.li>
                    ))}
                  </ul>
                </motion.div>
              </div>
            </div>

            <motion.div
              className="bg-white p-6 rounded-lg border-[#00BFA5] border-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8 }}
            >
              <h2 className="text-2xl font-bold mb-4 flex items-center gap-2 text-[#00BFA5]">
                Resources
              </h2>

              {/* Slider Component for Resources */}
              <Slider {...sliderSettings}>
                {scrollerData.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.2 + index * 0.1 }}
                    className="mb-4 cursor-pointer"
                    onClick={() => window.open(item.link, "_blank")}
                  >
                    <img src={item.image} alt={`Resource ${index + 1}`} className="w-1/2 h-auto rounded-lg shadow-md" />
                  </motion.div>
                ))}
              </Slider>
            </motion.div>
          </div>
        </motion.div>

        {/* Right Column - Gallery */}
        <SidebarGalleryPage></SidebarGalleryPage>
      </div>
    </div>
  );
}
